import { useQuery } from 'react-query'
import { fetchSiteById } from './fetchSiteById'

export const useFetchSiteById = (siteId: string) => {
  return useQuery(['fetchSiteById', siteId], fetchSiteById(siteId))
}
